import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { trackPageView } from 'dpl/util/analytics';

export default function SectionViewTracker({
  name,
  category,
  properties,
  children,
  threshold,
  rootMargin,
  triggerOnce
}) {
  const [ref] = useInView({
    triggerOnce,
    threshold,
    rootMargin,
    onChange: inView => {
      if (!inView) return;
      trackPageView({ name, category, properties });
    }
  });

  return <div ref={ref}>{children}</div>;
}

SectionViewTracker.propTypes = {
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  properties: PropTypes.object,
  children: PropTypes.node.isRequired,
  triggerOnce: PropTypes.bool,
  threshold: PropTypes.number,
  rootMargin: PropTypes.string
};

SectionViewTracker.defaultProps = {
  triggerOnce: true,
  threshold: 0.75,
  rootMargin: '0px',
  properties: null
};
